module.exports = __webpack_public_path__ + "img/c13.8cdfe4a5.png";